import {
  getNoticeList,
  getNoticeById,
  postNotice,
  updateNotice,
  deleteNotice,
  //Uploads
  getNoticeUploadListByNoticeId,
  postNoticeUpload,
  deleteNoticeUpload,
} from "@/services/notice.service";

import { formatDateEdit } from "@/utils/utils";
import { setPaginationDetails } from "../../utils/utils";

// initial state
const state = () => ({
  noticeModel: {
    // file: null,
    // Name: "duyuru test",
    // CenterId: "1",
    // CenterPeriodId: "2",
    // ClassId: undefined,
    // StartDate: "2022-02-02",
    // FinishDate: "2022-12-12",
    // Description: "<p>içerik	</p>",
    // EventCategoryId: undefined,
    // Score: undefined,
    // Active: true,
  },
});

// mutations
const mutations = {
  setNoticeModel(state, data) {
    state.noticeModel = data;
  },
};

// actions
const actions = {
  //Etkinlik Listesi
  async loadNoticeList(vuexContext, co) {
    return await getNoticeList(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;

      items.map((item, index) => {
        item.index = index + 1;
        item.Name = item.name;
        item.Description = item.description;
        item.Active = item.active;
        item.CountryId = item.countryId;
        item.StatetId = item.statetId;
        item.CitiesId = item.citiesId;
        item.ClassId = item.classId;
        item.CenterId = item.centerId;
        item.CenterPeriodId = item.centerPeriodId;

        item.StartDate = formatDateEdit(item.startDate);
        item.FinishDate = formatDateEdit(item.finishDate);
      });

      setPaginationDetails(co, totalCount, totalPages);

      return items;
    });
  },

  async loadNoticeById(vuexContext, noticeId) {
    return await getNoticeById(noticeId).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async postNotice(vuexContext, data) {
    await postNotice(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async updateNotice(vuexContext, data) {
    await updateNotice(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async deleteNotice(vuexContext, data) {
    await deleteNotice(data).then((response) => {
      let data = response;
      return data;
    });
  },

  //Notice Uploads
  async loadNoticeUploadListByNoticeId(vuexContext, noticeId) {
    return await getNoticeUploadListByNoticeId(noticeId).then((response) => {
      let data = response.data.data;
      let items = data.items;
      //   let totalCount = data.totalCount;
      //   let totalPages = data.totalPages;

      //   setPaginationDetails(co, totalCount, totalPages);
      return items;
    });
  },

  async postNoticeUpload(vuexContext, data) {
    await postNoticeUpload(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async deleteNoticeUpload(vuexContext, data) {
    await deleteNoticeUpload(data).then((response) => {
      let data = response;
      return data;
    });
  },

  addNoticeModel(vuexContext, data) {
    vuexContext.commit("setNoticeModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
